// src/PageA.js

// Assuming the Ballpit component is available in the same directory or correctly imported
import LiquidEther from './LiquidEther.js';

const PageB = () => {
 // Dependency array: Re-run only if 'navigate' changes (it won't, but ESLint likes it)
  return (
    // Outer div creates the full-screen black container, hiding overflow
    <div style={{ width: '100%', height: "100vh", position: 'relative' }}>
  <LiquidEther
    colors={[ '#fbff27', '#ff0000', '#ffee00']}
    mouseForce={20}
    cursorSize={100}
    isViscous={false}
    viscous={30}
    iterationsViscous={32}
    iterationsPoisson={32}
    resolution={0.5}
    isBounce={false}
    autoDemo={true}
    autoSpeed={0.5}
    autoIntensity={2.2}
    takeoverDuration={0.25}
    autoResumeDelay={3000}
    autoRampDuration={0.6}
  />
</div>
  );
};

export default PageB;